import { StructuredData } from './StructuredData';

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "AI Resume Screening for Faster, Consistent Hiring",
  "description": "Review candidates at scale with structured insights — while keeping human judgment in control. Designed for teams screening dozens to thousands of resumes per role.",
  "url": "https://beatview.ai/resume-screening",
  "isPartOf": {
    "@type": "WebSite",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://beatview.ai"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Resume Screening",
      "item": "https://beatview.ai/resume-screening"
    }
  ]
};

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Beatview AI Resume Screening",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "url": "https://beatview.ai/resume-screening",
  "description": "AI-powered resume screening tool that analyzes candidates against job-specific criteria with explainable scoring.",
  "featureList": [
    "Job match scoring",
    "Skills extraction",
    "Strengths and concerns analysis",
    "Explainable AI insights",
    "Bulk resume processing"
  ],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "creator": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "softwareHelp": {
    "@type": "WebPage",
    "url": "https://platform.beatview.ai/docs"
  }
};

export function ResumeScreeningStructuredData() {
  return <StructuredData data={[webPageSchema, breadcrumbSchema, softwareApplicationSchema]} />;
}
